import { useCallback, useState } from "react";
import { AuthGate } from "./auth/AuthGate";
import { logoutRequest } from "./auth/api";
import { SearchPage } from "./features/search/SearchPage";

export function App() {
  const [authed, setAuthed] = useState(false);

  const handleLogout = useCallback(async () => {
    await logoutRequest();
    window.location.reload();
  }, []);

  return (
    <div className="min-h-full bg-slate-50 text-slate-900 dark:bg-slate-950 dark:text-slate-100">
      <header className="border-b border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-900">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-6 py-4">
          <h1 className="text-xl font-semibold tracking-tight text-slate-900 dark:text-slate-100">
            🥷 Goblin Airlines
          </h1>
          <div className="flex items-center gap-3">
            <span className="hidden text-xs text-slate-500 dark:text-slate-400 sm:inline">
              buscador de vuelos baratos
            </span>
            {authed && (
              <button
                type="button"
                onClick={handleLogout}
                className="text-xs text-slate-500 hover:text-slate-900 dark:text-slate-400 dark:hover:text-slate-100"
              >
                salir
              </button>
            )}
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-5xl px-6 py-8">
        <AuthGate>
          <AuthedShell onAuthed={() => setAuthed(true)}>
            <SearchPage />
          </AuthedShell>
        </AuthGate>
      </main>
      <footer className="mx-auto max-w-5xl px-6 py-6 text-center text-xs text-slate-500 dark:text-slate-400">
        v0.1.0 · Cloudflare Workers + Pages · SerpAPI (free tier)
      </footer>
    </div>
  );
}

function AuthedShell({
  children,
  onAuthed,
}: {
  children: React.ReactNode;
  onAuthed: () => void;
}) {
  // Runs once when the gate switched to authenticated.
  // biome-ignore lint/correctness/useExhaustiveDependencies: onAuthed called on mount only
  if (typeof onAuthed === "function") {
    queueMicrotask(onAuthed);
  }
  return <>{children}</>;
}
